import script from "./CRM01_050INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM01_050INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM01_050INS.vue?vue&type=style&index=0&id=7f94b0f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f94b0f7"]])

export default __exports__